import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";
const StatementOfFaith = () => (
  <><NavigationBar/>
  {/* Hero Image */}

{/* Main Content */}
  <Layout>
  <div style={{ display: "grid" }}>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "block",
            padding: "20px",
            backgroundImage: "url('statement-of-faith-background.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
    }}
  >
          <Typography variant="h3" style={{textAlign: "center", color:"white"}}>
      <strong><br/>我們的宗旨<br/><br/></strong></Typography>
      <Typography variant="h3" style={{textAlign: "center", color:"white", fontSize:"1.5rem"}}><strong>宣化上人的宗旨也是廬山寺的宗旨：
<br/><br/>
凍死不攀緣，<br/>
餓死不化緣，<br/>
窮死不求緣，<br/><br/>
隨緣不變，不變隨緣，<br/>
抱定我們三大宗旨。<br/>
捨命為佛事，<br/>
造命為本事，<br/><br/>
正命為僧事，<br/>
即事明理，明理即事，<br/>
推行祖師一脈心傳。<br/><br/>

問自己是不是不爭？<br/>
問自己是不是不貪？<br/>
問自己是不是不求？<br/>
問自己是不是不自私？<br/>
問自己是不是不自利？<br/>
問自己是不是不打妄語？<br/>
問自己是不是吃一餐？<br/>
問自己是不是衣不離體？<br/>
這是祖師所傳的家風，我們遵從不易。<br/>
</strong>
      </Typography><br/>
  </div>
</div>
  </Layout>
  </>
)

export default StatementOfFaith
